import { createContext } from "react";
import { theme } from "../theme";
import { pngs } from "../app/constants";
import { Theme } from "@mui/material";
import { QueryStatus } from "../app/types";

type BrandingContextProps = {
  theme: Theme;
  logoFullMonoURL: string;
  logoSquareMonoURL: string;
  name: string;
  status: QueryStatus;
  error: string | null;
};

const defaultBrandingContext: BrandingContextProps = {
  theme: theme,
  logoFullMonoURL: pngs.simplLogoFull,
  logoSquareMonoURL: pngs.simplLogoSquare,
  status: "idle",
  name: "SIMPL",
  error: null
};

export const BrandingContext = createContext(defaultBrandingContext);
